import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import type {FaqArticleLink} from 'app/utils/knowledgeCenter/faqGrouping';
import type {FaqCategoryKey} from 'app/utils/knowledgeCenter/categories';

interface Props {
    currentSlug: string
    articles: FaqArticleLink[]
    categoryKey: FaqCategoryKey
}

const MAX_SECTION_ARTICLES = 4;

const KnowledgeCenterSectionAside = ({
    currentSlug,
    articles,
    categoryKey
}: Props): React.ReactElement => {
    const sectionArticles = articles.filter(article => article.name !== currentSlug).slice(0, MAX_SECTION_ARTICLES);

    return (
        <aside className="knowledge-center__aside">
            <h4 className="knowledge-center__aside-title">{I18n.t('knowledge_center.in_this_section')}</h4>
            {sectionArticles.map(article => <Link
                key={article.name}
                to={getLinkPath(`/faq/${article.name}`)}
                className="knowledge-center__aside-link"
            >
                {article.title}
            </Link>)}
            <Link
                to={getLinkPath(`/faq/category/${categoryKey}`)}
                className="knowledge-center__aside-more"
            >
                {I18n.t('knowledge_center.all_category_articles')}
            </Link>
        </aside>
    );
};

export default KnowledgeCenterSectionAside;
